// Shared client-side store for the global JD design document.
//
// Every JD candidate page and the admin design editor read from this single
// source of truth. Any admin save calls `refreshJdDesign()` so open tabs
// pick up new values without a hard reload.

import { useEffect, useSyncExternalStore } from "react";
import { api } from "./api";

const DEFAULT = {
    apply_button_text: "Apply Now",
    show_top_apply: true,
    show_bottom_apply: true,
    bottom_apply_align: "center",
    styles: {},
};

const state = {
    design: DEFAULT,
    loading: false,
    loaded: false,
    inflight: null,
};
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l) => {
    listeners.add(l);
    return () => listeners.delete(l);
};
const getSnapshot = () => state;

async function fetchOnce() {
    if (state.inflight) return state.inflight;
    state.loading = true;
    emit();
    state.inflight = (async () => {
        try {
            const { data } = await api.get("/public/jd-design");
            state.design = { ...DEFAULT, ...(data || {}) };
            state.loaded = true;
        } catch (_) {
            state.design = DEFAULT;
        } finally {
            state.loading = false;
            state.inflight = null;
            emit();
        }
    })();
    return state.inflight;
}

export function ensureJdDesignLoaded() {
    if (!state.loaded && !state.inflight) fetchOnce();
}

export async function refreshJdDesign() {
    state.inflight = null;
    state.loaded = false;
    return fetchOnce();
}

export function useJdDesign() {
    const snap = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    useEffect(() => {
        ensureJdDesignLoaded();
    }, []);
    return snap.design;
}
